import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import CtitemFilterCriteria from './CtitemFilterCriteria'
import CtitemList from './CtitemList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './CtitemAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setCtitemDashboardCtitemList } from '../../store/slice/PharmaSlice';

export default function CtitemListView({setShowEdit,setCtitemId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.ctitemDashboard);   

    const [filteredCtitemList, setFilteredCtitemList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { ctitemDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (ctitemDashboard.ctitemList.length>-1){
        setFilteredCtitemList(ctitemDashboard.ctitemList);
        transformToCardFormat(ctitemDashboard.ctitemList, setCardList);
      }
    },[ctitemDashboard.ctitemList])

    useEffect(()=>{
          transformToCardFormat(filteredCtitemList, setCardList);
      },[filteredCtitemList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.quantity==='' && filterCriteria.unitid==='' && filterCriteria.unitname==='' ){
            setFilteredCtitemList(ctitemDashboard.ctitemList);
            transformToCardFormat(ctitemDashboard.ctitemList, setCardList);

        } else {
            setFilteredCtitemList(
                ctitemDashboard.ctitemList
                    .filter(ctitem=> ctitem.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(ctitemDashboard.filteredCtitemList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <CtitemList
                    setShowEdit={setShowEdit}
                    setCtitemId = {setCtitemId}
                    tableList={filteredCtitemList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}